import styled from 'styled-components';
import color from 'tinycolor2';

export const ContentWrapper = styled.div`
  padding: 10px;
`;

export const ToggleSidebarButton = styled.button`
  height: 40px;
  width: 40px;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 0 4px 0 rgba(0,0,0,0.05), 0 1px 2px 0 rgba(0,0,0,0.05), 0 2px 4px 0 rgba(0,0,0,0.1);
  background-color: ${(props) => props.theme['color.surface']};
  outline: 0;
  box-sizing: border-box;
  transition-property: background, box-shadow;
  transition-duration: 0.3s;
  transition-timing-function: ease;

  &:hover,
  &:focus,
  &:active {
    background-color: ${(props) => color.mix(props.theme['color.text.body'], props.theme['color.surface'], 90).toString()};
  }

  &:focus,
  &:active {
    box-shadow: 0 0 0 4px ${(props) => color(props.theme['color.text.body']).setAlpha(0.3).toString()};
  }
`;

